import { VisibilityOff, Visibility } from "@mui/icons-material";
import {
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
  OutlinedInput,
  Stack,
  TextField,
} from "@mui/material";
import {
  logoutAtom,
  updateUserFullNameAtom,
  updateUserPasswordAtom,
} from "datasheets/model/atoms/UserAtoms";
import { useAtom, useSetAtom } from "jotai";
import { useState } from "react";
import { BaseDialog } from "./BaseDialog";

interface UserMenuProps {
  anchorEl: null | HTMLElement;
  setAnchorEl: React.Dispatch<React.SetStateAction<null | HTMLElement>>;
}
export function UserMenu({ anchorEl, setAnchorEl }: UserMenuProps) {
  const logout = useSetAtom(logoutAtom);
  const [editProfileModalOpen, setEditProfileModalOpen] = useState(false);
  const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false);
  function handleUserMenuClose() {
    setAnchorEl(null);
  }
  function handleSignOut() {
    logout();
    handleUserMenuClose();
  }
  function editProfile() {
    setEditProfileModalOpen(true);
    handleUserMenuClose();
  }
  function changePassword() {
    setChangePasswordModalOpen(true);
    handleUserMenuClose();
  }
  const open = Boolean(anchorEl);
  return (
    <>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleUserMenuClose}
      >
        {/* User Section */}
        <MenuItem onClick={editProfile}>Edit Profile</MenuItem>
        <MenuItem onClick={changePassword}>ChangePassword</MenuItem>

        {/* Logout section */}
        <Divider variant="inset" component="li" />
        <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
      </Menu>
      <EditProfileDialog
        modalIsOpen={editProfileModalOpen}
        setModalIsOpen={setEditProfileModalOpen}
      />
      <ChangePasswordDialog
        modalIsOpen={changePasswordModalOpen}
        setModalIsOpen={setChangePasswordModalOpen}
      />
    </>
  );
}

export interface ModalFormProps {
  modalIsOpen: boolean;
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function EditProfileDialog({ modalIsOpen, setModalIsOpen }: ModalFormProps) {
  const [currentName, updateName] = useAtom(updateUserFullNameAtom);
  const [name, setName] = useState(currentName);
  return (
    <BaseDialog
      modalIsOpen={modalIsOpen}
      setModalIsOpen={setModalIsOpen}
      dialogTitle="Edit Profile"
      resetFormValues={() => setName(currentName)}
      onSubmit={() => updateName(name)}
    >
      <Stack spacing={2}>
        <TextField
          type="text"
          id="name"
          label="Name"
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
      </Stack>
    </BaseDialog>
  );
}

function ChangePasswordDialog({ modalIsOpen, setModalIsOpen }: ModalFormProps) {
  const updatePassword = useSetAtom(updateUserPasswordAtom);
  let [password, setPassword] = useState("");
  let [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  return (
    <BaseDialog
      modalIsOpen={modalIsOpen}
      setModalIsOpen={setModalIsOpen}
      dialogTitle="Change Password"
      resetFormValues={() => {
        setPassword("");
        setNewPassword("");
        setShowPassword(false);
      }}
      onSubmit={() =>
        updatePassword({ newPassword: newPassword, currentPassword: password })
      }
    >
      <Stack spacing={2}>
        <FormControl>
          <InputLabel htmlFor="password">Current Password</InputLabel>
          <OutlinedInput
            type={showPassword ? "text" : "password"}
            id="password"
            label="Password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword((show) => !show)}
                  //onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <FormControl>
          <InputLabel htmlFor="newpassword">New Password</InputLabel>
          <OutlinedInput
            type={showPassword ? "text" : "password"}
            id="newpassword"
            label="New Password"
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword((show) => !show)}
                  //onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Stack>
    </BaseDialog>
  );
}
